import { supabase } from '../supabaseClient';

const MAX_QUEUE = 20;
const FLUSH_INTERVAL = 30000; // 30 seconds
let errorQueue = [];
let flushTimer = null;

const getSessionInfo = () => {
  try {
    const routingConfig = localStorage.getItem('hmgc_routing_config');
    const hasApiKey = routingConfig ? JSON.parse(routingConfig)?.googleMapsApiKey ? true : false : false;
    const googleMapsLoaded = !!window.google?.maps?.Map;
    
    return {
      hasApiKey,
      googleMapsLoaded,
      screenSize: `${window.innerWidth}x${window.innerHeight}`,
      timestamp: new Date().toISOString(),
    };
  } catch {
    return {};
  }
};

const flushQueue = async () => {
  if (errorQueue.length === 0) return;
  
  const batch = [...errorQueue];
  errorQueue = [];
  
  try {
    await supabase.from('error_logs').insert(batch);
  } catch (e) {
    // If logging fails, don't recurse — just lose the logs
    console.warn('Error logger flush failed:', e);
  }
};

const startFlushTimer = () => {
  if (!flushTimer) {
    flushTimer = setInterval(flushQueue, FLUSH_INTERVAL);
  }
};

export const logError = (message, extra = {}) => {
  const session = supabase.auth.getSession ? null : null; // avoid async here
  
  const entry = {
    error_message: typeof message === 'string' ? message : message?.message || String(message),
    error_stack: message?.stack || null,
    component: extra.component || null,
    url: window.location.href,
    user_agent: navigator.userAgent,
    extra_data: {
      ...getSessionInfo(),
      ...extra,
    },
    created_at: new Date().toISOString(),
  };

  errorQueue.push(entry);
  startFlushTimer();
  
  // Flush immediately if queue is full
  if (errorQueue.length >= MAX_QUEUE) {
    flushQueue();
  }
};

// Capture all unhandled errors
window.addEventListener('error', (event) => {
  logError(event.error || event.message, {
    component: 'window.onerror',
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
  });
});

// Capture unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  logError(event.reason || 'Unhandled promise rejection', {
    component: 'unhandledrejection',
  });
});

// Flush on page unload
window.addEventListener('beforeunload', () => {
  flushQueue();
});

export default { logError };